import { render } from "./NotificationsHost.vue?vue&type=template&id=53494b8b"
import script from "./NotificationsHost.vue?vue&type=script&lang=ts"
export * from "./NotificationsHost.vue?vue&type=script&lang=ts"
script.render = render

export default script